import { render, staticRenderFns } from "./OtherCamps.vue?vue&type=template&id=3a7e645a&lang=pug&"
import script from "./OtherCamps.vue?vue&type=script&lang=js&"
export * from "./OtherCamps.vue?vue&type=script&lang=js&"


/* normalize component */
import normalizer from "!../../../../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  null,
  null
  
)

export default component.exports